import React, { useState } from "react";
import "./UserExperienCard.css";

const Popup = ({ onClose, data }) => {
  const [inputValue, setInputValue] = useState("");

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Submitted:", inputValue);
    setInputValue("");
    onClose();
  };

  return (
    <div className="popup-container">
      <div className="popup">
        <span onClick={onClose} className="close-btn">
          &times;
        </span>
        <h2>Extension Settings</h2>

        <form onSubmit={handleSubmit}>
          <label>Bitly Access Token</label>
          <input
            type="text"
            id="inputField"
            placeholder="Enter your token"
            value={inputValue}
            onChange={handleChange}
            required
          />

          <label>Bitly Group GUID</label>
          <input
            type="text"
            id="inputField"
            placeholder="Enter group guid"
            value={inputValue}
            onChange={handleChange}
            required
          />
          <button type="submit" className="btn">Save</button>
        </form>

        {/* <p>This is the content of the popup.</p> */}
      </div>
    </div>
  );
};

export default Popup;
